import {Divider, styled} from '@mui/material'
import {Page, PageContent} from 'components/Page'
import {useNavigate} from 'react-router-dom'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'
import Tabs from 'components/Display/Tabs/Tabs'
import {FormProvider} from 'react-hook-form'
import {formatKeyFunctionsByType} from 'services/utils/tables'
import ClientHeader from './ClientHeader'
import ClientRequests from './ClientRequests'
import Button from 'components/Control/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import useClientScreen from 'logic/screens/useClientScreen'
import {useDeviceDetect} from 'services/hooks'
import {useState} from 'react'
import analyticsService from 'services/analytic'
import {tabs} from 'constants/tabs'

const Client = () => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const {isMobile} = useDeviceDetect()
    const [tab, setTab] = useState(0)

    const changeTab = (t) => {
        setTab(t)
        analyticsService.existingClientPressed('tab', {
            tab: tabs.client.keys[t],
        })
    }

    const {
        submit,
        editMode,
        toggleEdit,
        errorMessage,
        deleteClient,
        displayClient,
        methods,
    } = useClientScreen()

    if (!displayClient) {
        return null
    }

    return (
        <Page>
            <PageContent>
                <ClientHeader
                    showEditButton={tab === 0}
                    editMode={editMode}
                    toggleEdit={toggleEdit}
                    client={displayClient}
                    submit={submit}
                />

                <FormProvider {...methods}>
                    <Tabs
                        tab={tab}
                        setTab={changeTab}
                        itemName="client"
                        wrapperStyles={{
                            padding: `12px ${isMobile ? 20 : 110}px`,
                        }}
                        contentProps={{editMode}}
                        data={displayClient}
                        errorMessage={errorMessage}
                    />

                    {tab === 0 && (
                        <DeleteButton
                            isMobile={isMobile}
                            onClick={() => {
                                deleteClient()
                                navigate('/clients')
                            }}
                            startIcon={<DeleteIcon />}
                            variant="contained"
                            color="secondary">
                            {i18n.t('form.delete')}
                        </DeleteButton>
                    )}

                    <ClientCreationDate isMobile={isMobile}>
                        <Texts.BoldText>
                            {i18n.t('clients.clientCreationDate')}:
                        </Texts.BoldText>
                        <Texts.RegularText>
                            {formatKeyFunctionsByType().date(
                                displayClient.CreatTime,
                                i18n
                            )}
                        </Texts.RegularText>
                    </ClientCreationDate>
                </FormProvider>

                <Divider style={{width: '100%', paddingInline: 120}} />

                <ClientRequests
                    client={displayClient}
                    isMobile={isMobile}
                    analyticsPressFunction={
                        analyticsService.existingClientPressed
                    }
                />
            </PageContent>
        </Page>
    )
}

export default Client

const ClientCreationDate = styled('div')`
    display: flex;
    align-self: end;
    padding: 12px ${({isMobile}) => (isMobile ? 20 : 120)}px;
    gap: 8px;
`

const DeleteButton = styled(Button)`
    width: 120px;
    display: flex;
    justify-content: space-around;
    padding: 10px;
    align-items: center;
    align-self: end;
    line-height: 0;
    margin: 12px ${({isMobile}) => (isMobile ? 20 : 120)}px;
    & .MuiButton-startIcon {
        margin: 0;
        font-size: inherit;
    }
`
